import { ReactElement, useState } from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { onCapture } from "../../system/utils";
import { useSelector } from "react-redux";
import { IState } from "../../types";

const CaptureScreen = (): ReactElement => {
  const dataContext = useSelector((state: IState) => state.dataContext);
  const selected = useSelector((state: IState) => state.selectedNode);
  const [ waiting, setWaiting ] = useState<boolean>(false);

  const filename = `${dataContext?.title} - ${selected?.name}`;

  const processCapture = () => {
    setWaiting(true);

    setTimeout(() => {
      onCapture("ContentAreaID", filename)
        .then(() => {
          setWaiting(false);
        });
    }, 500);
  };

  return (
    <>
      {waiting
        ? <CircularProgress className=""/>
        : <IconButton onClick={processCapture} disabled={!dataContext || !selected}>
          <Tooltip title={"Snapshot"}>
            <CameraAltIcon/>
          </Tooltip>
        </IconButton>
      }
    </>
  );
};

export default CaptureScreen;
